import { useState } from 'react';
import { Flex } from '@/ui';
import type { CalendarFeedPlatform } from './calendarFeedPlatform.lib';
import { allCalendarFeedPlatforms } from './calendarFeedPlatform.lib';
import { PlatformButton } from './components/PlatformButton';

type Props = {
  url: string;
  platforms?: CalendarFeedPlatform[];
  /** Narrow surfaces (the 400px export rail): one per row, single-line label. */
  isCompact?: boolean;
  onPlatformClick?: (platform: CalendarFeedPlatform) => void;
};

export const CalendarFeedPlatformGrid = ({
  url,
  platforms = allCalendarFeedPlatforms,
  isCompact = false,
  onPlatformClick,
}: Props) => {
  const [lastClickedPlatform, setLastClickedPlatform] =
    useState<CalendarFeedPlatform | null>(null);

  const perRow = isCompact ? 1 : 2;
  const rows: CalendarFeedPlatform[][] = [];
  for (let i = 0; i < platforms.length; i += perRow) {
    rows.push(platforms.slice(i, i + perRow));
  }

  return (
    <Flex
      direction="column"
      gap={isCompact ? '2' : '4'}
      my={isCompact ? '2' : '4'}
    >
      {rows.map((row) => (
        <Flex
          direction={{ base: 'column', md: 'row' }}
          gap={isCompact ? '2' : '4'}
          key={row.join('-')}
        >
          {row.map((platform) => (
            <PlatformButton
              isCompact={isCompact}
              isLastClicked={lastClickedPlatform === platform}
              key={platform}
              platform={platform}
              url={url}
              onClick={() => {
                setLastClickedPlatform(platform);
                onPlatformClick?.(platform);
              }}
            />
          ))}
        </Flex>
      ))}
    </Flex>
  );
};
